import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import { DecisionDetail } from "./decision-detail";
import { CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1Document } from "../../../../../../generated";

interface DecisionDetailContainerProps {
  caseId: string;
}

export const DecisionDetailContainer: React.FC<DecisionDetailContainerProps> = (props) => {
  const {
    data: caseDecisionData,
    loading: caseDecisionLoading,
    error: caseDecisionError,
  } = useQuery(
    CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1Document,
    {
      variables: {
        credentialVerificationCaseV1Id: props?.caseId,
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={caseDecisionLoading}
      hasData={caseDecisionData}
      error={caseDecisionError}
      hasDataComponent={
        <DecisionDetail
          data={
            caseDecisionData?.credentialVerificationCaseV1?.caseDetails as CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment
          }
        />
      }
    />
  );
};
